import { render, staticRenderFns } from "./NewPlusPromoRoadblock.vue?vue&type=template&id=f6b7b998&scoped=true&"
import script from "./NewPlusPromoRoadblock.vue?vue&type=script&lang=js&"
export * from "./NewPlusPromoRoadblock.vue?vue&type=script&lang=js&"
import style0 from "./NewPlusPromoRoadblock.vue?vue&type=style&index=0&id=f6b7b998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b7b998",
  null
  
)

export default component.exports